import { render, staticRenderFns } from "./ProductVariantOptionList.vue?vue&type=template&id=5a5324c6&scoped=true&lang=pug&"
import script from "./ProductVariantOptionList.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProductVariantOptionList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5324c6",
  null
  
)

export default component.exports